
const digest = '0e65d427198c19dac4c467335cbd03469acf0c96bea49c7295021a1b83fae1b2';
const css = `._dividerLine_yf9v2_1 {
  border-top: 1px solid var(--theme-secondary-border);
  margin-top: 20px;
  margin-bottom: 20px;
}

._selected_yf9v2_7 {
  border-top: 2px solid var(--aha-blue-500);
  margin-bottom: 19px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"dividerLine":"_dividerLine_yf9v2_1","selected":"_selected_yf9v2_7"};
export { css, digest };
  